import { AutogenLayoutResponsibilityPendingActivitiesReport } from './autogen/AutogenLayoutResponsibilityPendingActivitiesReport';
import { DataSourceExecutionEvent, LookupModelSearchEvent, LookupModelSelectionEvent } from "@mcleod/components";
import { DateRange, DateUtil, DisplayType, DisplayValue, UserType } from '@mcleod/core';

export class ResponsibilityPendingActivitiesReport extends AutogenLayoutResponsibilityPendingActivitiesReport {

    onLoad(): void {
        // Set default values using display values (framework will map to DB codes)
        this.textboxCustomerProspectType.setSelectedItemFromDisplayValue("Both");
        this.textboxGroupBy.setSelectedItemFromDisplayValue("None");
        this.textboxSortBy.setSelectedItemFromDisplayValue("Date Due");

        // Set up dynamic customer lookup based on customer/prospect type selection
        this.textboxCustomerProspectTypeOnChange();
    }

    /**
     * Update the customer lookup model based on the selected customer/prospect type
     */
    textboxCustomerProspectTypeOnChange(): void {
        const typeValue = this.textboxCustomerProspectType.selectedItem?.value;

        // Get the textbox component from the excludable textbox
        const customerTextbox = this.excludabletextboxCustomers.textbox;

        if (!customerTextbox) {
            return;
        }

        customerTextbox.clear();
        // Update lookup model based on selection
        // A = Both (PROSP_CUST), B = Prospects Only (PROSPECT), C = Customers Only (CUST_ALL)
        switch (typeValue) {
            default:
            case "A": // Both
                customerTextbox.caption = "Customer(s) / Prospect(s)";
                break;
            case "B": // Prospects Only
                customerTextbox.caption = "Prospect(s)";
                break;
            case "C": // Customers Only
                customerTextbox.caption = "Customer(s)";
                break;
        }
    }

    textboxGroupByOnChange(): void {
        const groupByValue = this.textboxGroupBy.selectedItem?.displayValue;

        if (groupByValue && groupByValue !== "None") {
            this.checkboxPageBreak.enabled = true;
        } else {
            this.checkboxPageBreak.checked = false;
            this.checkboxPageBreak.enabled = false;
        }
    }

    switchIncludePastDueOnChange(): void {
        const includePastDue = this.switchIncludePastDue.checked;

        if (includePastDue) {
            this.textboxDueDateSingle.visible = true;
            this.textboxDueDate.visible = false;

            // Copy end date from range to single date
            const dateRangeText = this.textboxDueDate.text;
            if (dateRangeText) {
                const dateRange = DateRange.parseDateRange(dateRangeText);
                if (dateRange.endDate) {
                    this.textboxDueDateSingle.text = DateUtil.formatDate(dateRange.endDate, this.textboxDueDateSingle.format);
                }
            }
        } else {
            this.textboxDueDateSingle.visible = false;
            this.textboxDueDate.visible = true;

            // copy single date to both start and end of range
            const singleDateText = this.textboxDueDateSingle.text;
            if (singleDateText) {
                const singleDate = DateUtil.parseDateWithKeywords(singleDateText, true, false);
                const dateRange = new DateRange({
                    startDate: singleDate,
                    endDate: singleDate
                });
                this.textboxDueDate.text = DisplayValue.getDisplayValue(dateRange, DisplayType.DATERANGE, this.textboxDueDate.format);
            }
        }
    }

    textboxMarketingActivitiesBeforeLookupModelSearch(event) {
        event.filter.type_of = "C"; // customers. See RowAbstractMarketActivity.TYPE_OF_CUSTOMER/CARRIER
    }

    textboxOperationsUserBeforeLookupModelSearch(event) {
        event.filter.web_user_type = event.filter.web_user_type = `${UserType.LME}||${UserType.DATAFUSION}`; // U||E;
    }

    textboxCustomersBeforeLookupModelSearch(event) {
        const customersOrProspects = this.textboxCustomerProspectType.selectedItem?.value;
        switch (customersOrProspects) {
            default:
            case "A": // Both
                // No filtering
                break;
            case "B": // Prospects Only
                event.filter.type_of = "P"; // Filter to prospects only
                break;
            case "C": // Customers Only
                event.filter.type_of = "C"; // Filter to customers only
        }
    }

    /**
     * Handles hierarchy level changes.
     * Enables/disables hierarchy code field based on whether a level is selected.
     */
    private onLookupModelSelectionHierarchyLevel(event: LookupModelSelectionEvent) {
        this.textboxHierarchyCode.clear();
        this.textboxHierarchyCode.enabled = event.hasSelection();
    }

    /**
     * Filters hierarchy codes based on selected hierarchy level.
     */
    private textboxHierarchyCodeBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.hierarchy_level = this.textboxHierarchyLevel.getFirstLookupModelData()?.get("level_number");
    }

    /** This is an event handler for the beforeExecution event of sourceResponsibilityPendingActivitiesReport. */
    sourceResponsibilityPendingActivitiesReportBeforeExecution(event: DataSourceExecutionEvent) {
        event.filter.hierarchy_level_number = this.textboxHierarchyLevel.getFirstLookupModelData()?.get("level_number");
    }
}
